/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InformationRequestChildQuestion = {
  readonly id?: number;
  name: string;
  question_type: InformationRequestChildQuestion.question_type;
  description?: string | null;
  readonly answered?: boolean;
  readonly answer_display?: string | null;
};
export namespace InformationRequestChildQuestion {
  export enum question_type {
    TEXT = 'text',
    DATE = 'date',
    DROPDOWN = 'dropdown',
    MULTIPLE = 'multiple',
  }
}

